// Add hubspot script to end of body
// Only called once app is in logged in state as we don't want elements added to loading states
let hubspotScriptAdded = false;
export async function addHubspotScript() {
  if (import.meta.env.VITE_HUBSPOT_ENABLED !== "true") return;
  if (hubspotScriptAdded) return;
  hubspotScriptAdded = true;
  const element = document.createElement("script");
  element.type = "text/javascript";
  element.src = "https://js.hs-scripts.com/20335080.js";
  element.id = "hs-script-loader";
  element.async = true;
  // Delay script until page is ready
  const addScript = () => {
    document.body.appendChild(element);
    console.debug("Hubspot script added");
  };
  if (document.readyState === "complete") addScript();
  else window.addEventListener("load", addScript);
}

// Remove the messages button from the screen, cannot be reversed
// Should be run as user is logging out so spinner screen is clean.
export function removeHubspotMessages() {
  const hubspotMessages = document.querySelectorAll(
    "#hubspot-messages-iframe-container"
  );
  hubspotMessages.forEach((message) => message.remove());
}
